<template>
  <div>
    <v-header v-if="isLogin" />
    <router-view />
  </div>
</template>

<script>
import vHeader from "./components/vHeader.vue"
export default {
  name: "App",
  components: { vHeader },
  data() {
    return {
      telegramWebApp: null
    }
  },
  created() {
    this.initTelegramWebApp()
  },
  methods: {
    initTelegramWebApp() {
      if (window.Telegram && window.Telegram.WebApp) {
        this.telegramWebApp = window.Telegram.WebApp
        this.telegramWebApp.ready()
        this.telegramWebApp.expand()
        this.telegramWebApp.setHeaderColor('#ffffff')
        this.telegramWebApp.setBackgroundColor('#ffffff')

        if (this.telegramWebApp.initData) {
          console.log('Raw initData:', this.telegramWebApp.initData)
        }

        if (this.telegramWebApp.initDataUnsafe && this.telegramWebApp.initDataUnsafe.user) {
          const user = this.telegramWebApp.initDataUnsafe.user
          console.log('Telegram user ID:', user.id)
          console.log('Telegram user:', user)

          // Сохраняем ID пользователя в localStorage и Vuex
          localStorage.setItem('telegram-id', user.id)
          this.$store.commit('updateTelegramId', user.id)
          console.log('Telegram ID сохранен в хранилище:', user.id)

          localStorage.setItem('telegram-user-data', JSON.stringify(user))
        } else {
          console.log('Не удалось получить данные пользователя из initDataUnsafe')
          try {
            if (this.telegramWebApp.CloudStorage) {
              this.telegramWebApp.CloudStorage.getItem('user_id', (error, value) => {
                if (error) {
                  console.log('CloudStorage error:', error)
                } else {
                  console.log('CloudStorage user_id:', value)
                }
              })
            }
          } catch (e) {
            console.error('Ошибка при получении данных через CloudStorage:', e)
          }
        }
      } else {
        console.log('Telegram WebApp API не доступен. Приложение не запущено в Telegram Mini App.')
      }
    }
  },
  computed: {
    isLogin() {
      return this.$route.path !== "/login"
    },
  },
}
</script>

<style scoped lang="scss">
* {
  background-color: #ffffff;
}
</style>
